import VampTooltip from "./VampTooltip";
import { STANDING_TIPS, type VampStanding } from "./vampStanding";

const STYLES: Record<VampStanding, string> = {
  Excessive: "bg-error-500 text-white font-semibold",
  "Above Standard": "bg-warning-50 text-warning-700 font-semibold",
  "Good Standing": "bg-success-50 text-success-700 font-semibold",
  "Safe": "bg-gray-100 text-gray-500 font-medium",
};

export default function VampStandingPill({ standing }: { standing: VampStanding }) {
  return (
    <VampTooltip title={STANDING_TIPS[standing]} placement="top-end">
      <span className={`inline-flex items-center whitespace-nowrap rounded-full px-[9px] py-0.5 text-[11px] leading-[17px] ${STYLES[standing]}`}>
        {standing}
      </span>
    </VampTooltip>
  );
}
